import { render, staticRenderFns } from "./MultipollCreate.vue?vue&type=template&id=1d542253&scoped=true&"
import script from "./MultipollCreate.vue?vue&type=script&lang=ts&"
export * from "./MultipollCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d542253",
  null
  
)

export default component.exports